<script setup>
import { computed } from 'vue';
import { format, fromUnixTime } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import BaseBubble from './Base.vue';
import { useMessageContext } from '../provider.js';

const { content, createdAt } = useMessageContext();

const readableTime = computed(() => {
  const messageTime = fromUnixTime(createdAt.value);
  return format(messageTime, "d 'de' MMMM, HH:mm", { locale: ptBR });
});
</script>

<template>
  <BaseBubble
    v-tooltip.top="readableTime"
    class="px-3 py-1 !rounded-xl flex min-w-0 items-center gap-2"
    data-bubble-name="activity"
  >
    <span v-dompurify-html="content" :title="content" />
  </BaseBubble>
</template>
